import { useState, useRef } from 'react';

// Кэш для хранения дат коммитов
const commitCache = new Map();

export const useLastCommit = (githubOwner, repoName) => {
    const [lastCommitDate, setLastCommitDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchedRef = useRef(false);

    const fetchLastCommit = async () => {
        if (!githubOwner || !repoName) return;

        const cacheKey = `${githubOwner}/${repoName}`;

        // Проверяем кэш
        if (commitCache.has(cacheKey)) {
            setLastCommitDate(commitCache.get(cacheKey));
            return;
        }

        if (fetchedRef.current) return;
        fetchedRef.current = true;

        setIsLoading(true);
        setError(null);

        try {
            // Пробуем получить основную ветку (main/master)
            let response = await fetch(
                `https://api.github.com/repos/${githubOwner}/${repoName}/branches/main`
            );

            // Если main не существует, пробуем master
            if (!response.ok) {
                response = await fetch(
                    `https://api.github.com/repos/${githubOwner}/${repoName}/branches/master`
                );
            }

            if (!response.ok) {
                throw new Error('Repository not accessible');
            }

            const data = await response.json();
            const commitDate = new Date(data.commit.commit.author.date);

            const formattedDate = commitDate.toLocaleDateString('ru-RU', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'Europe/Moscow'
            });

            // Сохраняем в кэш на 10 минут
            commitCache.set(cacheKey, formattedDate);
            setTimeout(() => commitCache.delete(cacheKey), 10 * 60 * 1000);

            setLastCommitDate(formattedDate);
        } catch (err) {
            console.error('Error fetching commit date:', err);
            setError('Не удалось получить данные');
            setLastCommitDate(null);
        } finally {
            setIsLoading(false);
        }
    };

    return { lastCommitDate, isLoading, error, fetchLastCommit };
};